export default {
  offers: [],
  selectedOffer: null,
  appPhase: "email", // 'email' | 'otp' | 'form' | 'success'
  otpVerified: false,
  candidateEmail: "",
  loading: {
    offers: false,
    sendOtp: false,
    verifyOtp: false,
    submit: false,
  },
  errors: {
    offers: "",
    email: "",
    otp: "",
    submit: "",
  },
};
